import { getWillShowNav4 } from '@atlassian/jira-navigation-apps-sidebar-nav4-rollout-core/src/common/utils/get-will-show-nav4/index.tsx';
import { useCurrentRoute } from '@atlassian/jira-platform-router-utils/src/index.tsx';

export const useInsight = () => {
	const route = useCurrentRoute();

	if (route.navigation) {
		return route.navigation.menuId === 'INSIGHT';
	}

	return false;
};

export const useInsightObjectSchemaSidebar = () => {
	const route = useCurrentRoute();
	if (getWillShowNav4()) return false;
	return route.name === 'servicedesk-cmdb-object-schema';
};
